import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
//import AddIcon from '@mui/icons-material/Add';
//import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
//import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  "& .MuiInputBase-root": {
    height: 35,
    borderRadius: 0,
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPagePromotionalBanner() {
  const [loading, setLoading] = useState(false);
  const [promoBanner, setPromoBanner] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const handlePromoBannerSubmit = async (index) => {
    let item = promoBanner[index];
    let promoBannerReqData = {
      'id': item.id ? item.id : "",
      'page_link': item.page_link ? item.page_link : "",
      'collection_name': item.collection_name ? item.collection_name : "",
    };

    // Convert file to base64 if a new file was uploaded
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    if (item.promotional_banner_file) {
      promoBannerReqData.promotional_banner_image = await convertToBase64(item.promotional_banner_file);
    } else if (item.promotional_banner_image && item.promotional_banner_image.startsWith("data:")) {
      // Already base64
      promoBannerReqData.promotional_banner_image = item.promotional_banner_image;
    } else {
      promoBannerReqData.promotional_banner_image = "";
    }

    let promoBannerResData = await postData(
      "/api/theme/landing_promotional",
      promoBannerReqData
    );

    if (promoBannerResData["data"]["code"] !== 200) {
      alert("Promo banner data saved successfully");
      setLoading(false);
      return true;
    } else {
      alert("Error saving promo banner data");
      setLoading(false);
    }
    return false;
  };

  useEffect(() => {
    async function fetchData() {
      let resData = await getData("/api/theme/landing_promotional");
      console.log(resData);
      let promo_data = resData["data"]["promo_banners"];
      if (promo_data) {
        console.log(promo_data);
        if (promo_data) {
          setPromoBanner(promo_data);
        }
      } else {
        console.error("Error fetching banner data:", resData.message);
      }

      let collectionResData = await getData("/api/product/product-collection");
      console.log(collectionResData);
      let collections_data = collectionResData["data"]["live_collections"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          collection_url: collection.collection_url || "",
        }));
        setCollectionOptions(formattedCollections);
      } else {
        console.error("Error fetching collection data:", collectionResData.message);
      }

      setLoading(false);
    }

    fetchData();
  }, []);

  // Replace the old handleImageUpload with a new one matching LandingPageBanner.js
  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const img = new window.Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 1440 && img.height === 200) {
          // Revoke previous object URL if it exists
          setPromoBanner((prev) => {
            const updated = [...prev];
            if (
              updated[index].promotional_banner_image &&
              updated[index].promotional_banner_image.startsWith("blob:")
            ) {
              URL.revokeObjectURL(updated[index].promotional_banner_image);
            }
            updated[index] = {
              ...updated[index],
              promotional_banner_image: imageUrl, // Store the object URL for preview
              promotional_banner_file: file, // Store the file object
            };
            return updated;
          });
          setPreviewImage(imageUrl);
          // Reset the file input value so the same file can be uploaded again
          event.target.value = "";
        } else {
          URL.revokeObjectURL(imageUrl); // Clean up if not valid
          alert("Image must be 1440px wide and 200px tall.");
        }
      };
    }
  };

  const handleLinkChange = (event, newValue, index) => {
    const updatedPromoBanner = [...promoBanner];
    if (newValue?.value === "none") {
      updatedPromoBanner[index].collection = ""; // Clear the collection when "None" is selected
      updatedPromoBanner[index].collection_url = ""; // Clear the URL
      updatedPromoBanner[index].collection_name = ""; 
      updatedPromoBanner[index].page_link = ""; // Clear the collection when "None" is selected
      updatedPromoBanner[index].isEditable = true; // Enable the text field
    } else {
      updatedPromoBanner[index].collection = newValue?.value || "";
      updatedPromoBanner[index].collection_url = newValue?.collection_url || ""; // Update the URL to the selected collection's page_link
      updatedPromoBanner[index].collection_name = newValue?.label || "";
      updatedPromoBanner[index].page_link = newValue?.collection_url || ""; // Set page_link
      updatedPromoBanner[index].isEditable = false; // Disable the text field
    }
    setPromoBanner(updatedPromoBanner);
  };

  const handleURLChange = (e, index) => {
    const updatedPromoBanner = [...promoBanner];
    updatedPromoBanner[index].page_link = e.target.value;
    setPromoBanner(updatedPromoBanner);
  };

  /* const addPromoBanner = () => {
    const newBanner = { id: null, promotional_banner_image: "", collection_url: "" }; // Initialize a new empty banner
    setPromoBanner([...promoBanner, newBanner]); // Add the new banner to the existing array
  };

  const deletePromoBanner = (index) => {
    const updatedPromoBanner = [...promoBanner];
    updatedPromoBanner.splice(index, 1);
    setPromoBanner(updatedPromoBanner);
  }; */

  return (
    <Accordion sx={sectionStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton color="" component="icon">
            <GridViewIcon />
          </IconButton>
          <Typography variant="h7">Promotion Banner</Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            {promoBanner.map((item, index) => (
              <Box
                key={item.id}
                sx={{
                  padding: 4,
                  pt: 0,
                  pb: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  borderRadius: 0,
                  position: "relative",
                }}
              >
                {/*<IconButton sx={{ color: 'red', position: 'absolute', top: 8, right: 8 }} onClick={() => deletePromoBanner(index)}>
                                    <DeleteOutlinedIcon />
                                </IconButton>*/}
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography key={index} sx={{ mt: 1 }}>
                    <figure>
                      <img
                        src={item.promotional_banner_image || previewImage}
                        alt="Promotion Banner"
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          height: "auto",
                          border: "1px solid #ccc",
                          marginBottom: 2,
                        }}
                      />
                      <figcaption style={{ fontSize: 14, fontFamily: "Inter", fontWeight: 500 }}>W 1440px / H 200px</figcaption>
                    </figure>
                  </Typography>
                  <IconButton
                    sx={{ color: "black" }}
                    component="label"
                  >
                    <FileUploadOutlinedIcon />
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(e) => handleImageUpload(e, index)}
                    />
                  </IconButton>
                </div>
                <Box sx={{ display: "flex-col", alignItems: "center" }}>
                  <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14,  }}>
                    Link collection page
                  </Typography>
                  <Autocomplete
                    options={[
                      { label: "None", 
                        value: "none", 
                        page_link: "" },
                      ...collectionOptions,
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      collectionOptions.find(
                        (option) => 
                          option.value === item.collection ||
                          option.label === item.collection_name
                      ) || { 
                        label: promoBanner.collection_name || "None", 
                        value: promoBanner.collection_url || "none", 
                        collection_url: promoBanner.collection_url || "",
                      }
                    }
                    onChange={(event, newValue) =>
                      handleLinkChange(event, newValue, index)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}                        
                        fullWidth
                        sx={{
                          ...inputStyle,
                          width: { xs: "100%", sm: "100%", md: "800px" },
                          marginBottom: 2,
                          mr: 15.5,
                        }}
                      />
                    )}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex-col",
                    alignItems: "center",
                    gap: 2,
                    marginBottom: 1,
                  }}
                >
                  <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14 }}>
                    Url to link collection page
                  </Typography>
                  <TextField
                    fullWidth                    
                    placeholder="URL"
                    variant="outlined"                    
                    sx={{
                      ...inputStyle,
                      width: { xs: "100%", sm: "100%", md: "800px" },
                      marginBottom: 2,
                    }}
                    value={item.page_link || ""}                
                    onChange={(e) => handleURLChange(e, index)}
                    disabled={!item.isEditable}
                  />
                  <Button
                    onClick={() => handlePromoBannerSubmit(index)}
                    sx={{ ...buttonStyle, mb: 0, mt: 0, ml: 1 }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            ))}
            {/*<IconButton variant="contained" onClick={addPromoBanner} sx={{ ...buttonStyle }}>
                            <AddIcon />
                        </IconButton>*/}
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
